var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingGroupBalancingValve = function SvgDCoolingGroupBalancingValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 320,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "88.5 317.82 100.99 324.94 88.51 332.09 88.5 317.82",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,318.68l10.98,6.26-10.97,6.29v-12.55M88,316.96v16s14-8.01,14-8.01l-14-7.98h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "103.01 324.94 115.49 317.82 115.5 332.09 103.01 324.94",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99,318.68v12.55s-10.98-6.29-10.98-6.29l10.98-6.26M115.99,316.96l-13.99,7.98,14,8.01v-16h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "95.83 335.36 105.41 320.72 106.45 321.4 108.55 315 103.53 319.49 104.58 320.17 95 334.82 95.83 335.36",
    fill: "#1d1d1b"
  })))));
};
export default SvgDCoolingGroupBalancingValve;